















































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { dictServe, doublePrevention, institutionServer, performanceServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';
import { arrayToTree } from '@/util/arrayToTree';

import ChooseDeptOfStaff from '@/views/inspectionContents/checklist/unit/choosePeople.vue';
import Axios from 'axios';

@Component({
  components: { ChooseDeptOfStaff },
})
export default class PublicProp extends Vue {
  @Prop(Object) rowProp: any;

  visible = false;
  canEdit = false;
  title = '';
  formData: any = {
    annex: '', // 附件（最多10份）上传附件的时候的接口值
    drillSituation: '', // 演练情况
    drillTime: '', // 演练时间
    image: '', // 图片（最多10份）上传图片的时候的接口值
    joinDrillUnit: '', // 参与单位
    location: '', // 演练地点
    name: '', // 演练名称
    reportDate: '', // 上报日期
    staffNum: '', // 演练人数
    way: '', // 演练方式
    planId: '', // 应急演练计划id
    emergencyPlanId: '', // 应急预案id
    summaryAnnex: '', // 演练总结
    assessAnnex: '', // 演练评估
    drillHierarchy: '', // 实际演练层级
    workshopId: '', // 车间id
    workshopName: '', // 车间名称
    workshopSectionId: '', // 工段id
    workshopSectionName: '', // 工段名称
    remark: '', // 备注
    investment: '',
    courseDescribe: '',
    coursePicture: '',
    signInStaffIdList: [],
  };
  planIdList: any = []; // 应急演练计划
  wayList: any = []; // 演练方式
  emergencyPlanList: any = []; // 预案
  ruleForm: any = {
    name: [
      { required: true, message: '请输入活动名称', trigger: 'blur' },
      { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' },
    ],
  };

  topDeptList: any = []; // 顶级部门
  workshopSectionList: any = []; // 二级部门
  workshopData: any = '';
  workshopSectionData: any = '';

  private staffNames: any = ''; // 签到人员

  private uploadUrl: any = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex'; // 附件
  private uploadUrl1: any = publishObjectPath.serverUrl + '/api/sysManage/sysFile'; // 图片
  private headers: any = {};

  private fileList: any = []; // 附件
  private fileList1: any = []; // 演练图片
  private fileList2: any = []; // 演练总结
  private fileList3: any = []; // 演练评估
  private fileListCourse: any = []; // 演练过程图片

  created() {
    this.getPlanAll(); // 获取演练计划的下拉
    this.getWayList(); // 获取演练方式的下拉
    this.getEmergencyPlanList(); // 获取预案方案
    this.getTopDeptData(); // 获取顶级部门
    switch (this.rowProp.type) {
      case 'add':
        this.canEdit = false;
        this.title = '添加演练记录';
        break;
      case 'detail':
        this.title = '演练记录详情';
        this.canEdit = true;
        this.getDetail(this.rowProp.data.id);
        break;
      case 'edit':
        this.title = '编辑演练记录';
        this.canEdit = false;
        this.getDetail(this.rowProp.data.id);
        break;
      default:
        this.title = '';
    }
  }
  mounted() {
    this.headers.Authorization = localStorage.getItem('token');
  }

  private choseSponsor() {
    if (this.canEdit) return;
    let chooseStaffArr: any = [];
    if (this.formData.signInStaffIdList && this.formData.signInStaffIdList.length) {
      const staffNameArr: any = this.staffNames.split(',');
      this.formData.signInStaffIdList.forEach((item: any, index: any) => {
        chooseStaffArr.push({
          id: item,
          name: staffNameArr[index],
        });
      });
    } else {
      chooseStaffArr = [];
    }
    (this.$refs['ChooseDeptOfStaff'] as any).showDialog(chooseStaffArr, 'more');
  }
  getStaffData(data: any) {
    if (data && data.length) {
      this.formData.signInStaffIdList = data.map((item: any) => item.id);
      this.staffNames = data.map((item: any) => item.name).join(',');
    }
  }

  /* 获取演练计划的下拉 */
  getPlanAll() {
    doublePrevention.getPlanAll().then((res: any) => {
      if (res.code === '200') {
        this.planIdList = res.data;
      } else {
        this.$message.warning('获取应急演练计划的下拉数据失败！');
      }
    });
  }

  /* 演练方式 的下拉 */
  getWayList() {
    dictServe.getDetailsMapByName('emergencyDrillWay').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.wayList = helpArr;
      } else {
        this.$message.warning('获取应急队伍类型下拉数据失败！');
      }
    });
  }
  /* 预案列表  */
  getEmergencyPlanList() {
    doublePrevention.getEmergencyDrillPlanAll({}).then((res: any) => {
      if (res.code === '200') {
        this.emergencyPlanList = res.data;
      }
    });
  }

  /* 顶级部门 */
  getTopDeptData() {
    institutionServer.getAllTopDeptData({}).then((res: any) => {
      if (res.code === '200') {
        this.topDeptList = res.data;
      }
    });
  }

  planChange(e: any) {
    if (e) {
      const findData: any = this.planIdList.find((item: any) => item.id === e);
      this.formData.emergencyPlanId = findData.emergencyPlanId;
    } else {
      this.formData.emergencyPlanId = '';
    }
  }
  topDeptChange(data: any) {
    if (data) {
      this.formData.workshopId = data.deptId;
      this.formData.workshopName = data.deptName;
      this.getNextDeptList(data.deptId);
    } else {
      this.formData.workshopId = '';
      this.formData.workshopName = '';
      this.workshopSectionList = [];
    }
  }

  getNextDeptList(pid: any) {
    institutionServer.getAllData({ pid }).then((res: any) => {
      if (res.code === '200') {
        this.workshopSectionList = arrayToTree(res.data);
      }
    });
  }

  hideDialog() {
    this.fileListCourse = [];
    this.fileList = [];
    this.fileList1 = [];
    this.fileList2 = [];
    this.fileList3 = [];
    this.$emit('getTableData');
  }

  submitForm() {
    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        const obj: any = {
          name: this.formData.name,
          planId: this.formData.planId,
          emergencyPlanId: this.formData.emergencyPlanId,
          way: this.formData.way,
          staffNum: this.formData.staffNum,
          drillTime: this.formData.drillTime,
          reportDate: this.formData.reportDate,
          location: this.formData.location,
          joinDrillUnit: this.formData.joinDrillUnit,
          drillHierarchy: this.formData.drillHierarchy,
          remark: this.formData.remark,
          drillSituation: this.formData.drillSituation,
          courseDescribe: this.formData.courseDescribe,
          investment: this.formData.investment,
          summaryAnnex: this.formData.summaryAnnex,
          assessAnnex: this.formData.assessAnnex,
          annex: this.formData.annex,
          image: this.formData.image,
          coursePicture: this.formData.coursePicture,
          signInStaffIdList: this.formData.signInStaffIdList,
        };
        if (obj.drillHierarchy === '车间级(中心、部室)') {
          obj.workshopId = this.formData.workshopId;
          obj.workshopName = this.formData.workshopName;
        } else if (obj.drillHierarchy === '工段级') {
          obj.workshopId = this.formData.workshopId;
          obj.workshopName = this.formData.workshopName;
          if (this.workshopSectionData) {
            obj.workshopSectionId = this.workshopSectionData.id ? this.workshopSectionData.id : '';
            obj.workshopSectionName = this.workshopSectionData.id ? this.workshopSectionData.name : '';
          }
        }
        if (this.title === '添加演练记录') this.addEmergencyDrillRecord(obj);
        if (this.title === '编辑演练记录') this.editEmergencyDrillRecord(obj);
      } else {
        return false;
      }
    });
  }

  /* 新增的接口 */
  addEmergencyDrillRecord(obj: any) {
    doublePrevention
      .addEmergencyDrillRecord({
        ...obj,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功新增一条数据！');
          this.hideDialog();
        } else {
          this.$message.warning('网络错误，请稍后再试！');
        }
      });
  }

  /* 编辑的接口 */
  editEmergencyDrillRecord(obj: any) {
    doublePrevention
      .editEmergencyDrillRecord({
        ...obj,
        id: this.formData.id,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('成功新增一条数据！');
          this.hideDialog();
        } else {
          this.$message.warning('网络错误，请稍后再试！');
        }
      });
  }

  /* 详情的接口 */
  getDetail(id: any) {
    doublePrevention.getSingleEmergencyDrillRecord(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        if (res.data.imageList) {
          this.fileList1 = res.data.imageList.map((item: any) => {
            return {
              ...item,
              url: publishObjectPath.imgPathWater + item.path,
            };
          });
        }
        if (res.data.coursePictureData) {
          this.fileListCourse = res.data.coursePictureData.map((item: any) => {
            return {
              ...item,
              url: publishObjectPath.imgPathWater + item.path,
            };
          });
        }

        this.fileList = res.data.annexList;
        if (res.data.assessAnnex) {
          performanceServer.getSysFile(res.data.assessAnnex).then((res: any) => {
            if (res.code === '200' && res.data && res.data.length > 0) {
              this.fileList2 = res.data;
            }
          });
        }
        if (res.data.summaryAnnex) {
          performanceServer.getSysFile(res.data.summaryAnnex).then((res: any) => {
            if (res.code === '200' && res.data && res.data.length > 0) {
              this.fileList3 = res.data;
            }
          });
        }
        if (res.data.workshopId) {
          this.workshopData = {
            deptId: res.data.workshopId,
            deptName: res.data.workshopName,
          };
          this.getNextDeptList(res.data.workshopId);
        }
        if (res.data.workshopSectionId) {
          this.workshopSectionData = {
            id: res.data.workshopSectionId,
            name: res.data.workshopSectionId,
          };
        }
        if (res.data.signInStaffList && res.data.signInStaffList.length) {
          this.formData.signInStaffIdList = res.data.signInStaffList.map((item: any) => item.staffId);
          this.staffNames = res.data.signInStaffList.map((item: any) => item.staffName).join(',');
        } else {
          this.formData.signInStaffIdList = [];
          this.staffNames = '';
        }
      } else {
        this.$message.warning('获取数据失败！');
      }
    });
  }

  /* 导入用到的 */
  /* 附件 */
  private handleRemove(file: any, fileList: any) {
    const helpArr: any = [];
    fileList.forEach((id: any) => {
      helpArr.push(id.id);
    });
    this.formData.annex = helpArr;
  }

  private handleExceed(files: any, fileList: any) {
    this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }

  private beforeAvatarUpload(files: any, fileList: any) {
    // 限制上传文件类型
    const suffix = files.name.substring(files.name.lastIndexOf('.') + 1);
    // console.log(suffix);
    if (suffix === 'PNG' || suffix === 'JPG' || suffix === 'JPEG' || suffix === 'BMP' || suffix === 'GIF' || suffix === 'SVG' || suffix === 'PDF' || suffix === 'TXT' || suffix === 'DOC' || suffix === 'DOCX' || suffix === 'XLSX' || suffix === 'XLS' || suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg' || suffix === 'bmp' || suffix === 'gif' || suffix === 'svg' || suffix === 'pdf' || suffix === 'txt' || suffix === 'doc' || suffix === 'docx' || suffix === 'xlsx' || suffix === 'xls') {
      return true;
    } else {
      this.$message.warning('上传格式不正确，请上传格式为：PNG,JPG,JPEG,BMP,GIF,SVG,PDF,TXT,DOC,DOCX,XLSX,XLS！');
      return false;
    }
  }

  private handleAvatarCardFrontSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    // arr.push(this.formData.annex);
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.name);
      }
    });
    this.formData.annex = arr;
    console.log(this.formData.annex);
  }
  private handlePreviewFile(file: any) {
    let pathFile: any = '';
    if (file.response) {
      pathFile = file.response.data[0].path;
    } else {
      pathFile = file.path;
    }
    const urlPath: any = publishObjectPath.imgPathWater + pathFile;
    window.open(urlPath, '_blank');
  }

  /* 图片 */

  private beforeAvatarUpload1(files: any, fileList: any) {
    // 限制上传文件类型
    const suffix = files.name.substring(files.name.lastIndexOf('.') + 1);
    if (suffix === 'PNG' || suffix === 'JPG' || suffix === 'JPEG' || suffix === 'BMP' || suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg' || suffix === 'bmp') {
      return true;
    } else {
      this.$message.warning('上传格式不正确，请上传格式为：PNG,JPG,JPEG,BMP！');
      return false;
    }
  }

  private handleSuccess1(response: any, file: any, fileList1: any) {
    // console.log(response, file, fileList1);
    console.log(this.formData.image); // 旧图
    const arr: any = []; // 新上传的图片
    fileList1.forEach((item: any) => {
      console.log(item, 332);
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    console.log(arr);
    // this.fileList1 = arr.toString();
    this.formData.image = arr.toString();
    console.log(this.formData.image, 'this.formData.image');
  }

  private handleRemove1(file: any, fileList1: any) {
    console.log(fileList1);
    this.fileList1 = fileList1;
    const helpArr: any = [];
    this.fileList1.forEach((item: any) => {
      if (item.response) {
        helpArr.push(item.response.data[0].id);
      } else {
        helpArr.push(item.id);
      }
    });
    this.formData.image = helpArr.toString();
  }
  private handleSuccessCourse(response: any, file: any, fileList: any) {
    const arr: any = []; // 新上传的图片
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.coursePicture = arr.toString();
  }

  private handleRemoveCourse(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.coursePicture = arr.toString();
  }

  /* 图片 */
  private handleRemoveAssess(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.assessAnnex = arr.toString();
  }
  private handleAvatarCardFrontSuccessAssess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.assessAnnex = arr.toString();
  }
  private handleRemoveSummary(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.summaryAnnex = arr.toString();
  }
  private handleAvatarCardFrontSuccessSummary(response: any, file: any, fileList: any) {
    const arr: any = [];
    // arr.push(this.formData.annex);
    fileList.forEach((item: any) => {
      if (item.response) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.summaryAnnex = arr.toString();
  }
  private handlePreview(file: any) {
    const urlPath: any = publishObjectPath.imgPathWater + file.path;
    this.getBlob(urlPath).then((blob: any) => {
      this.saveAs(blob, file.name);
    });
  }
  getBlob = (url: any) => {
    return new Promise((resolve: any) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status == 200) {
          resolve(xhr.response);
        }
      };
      xhr.send();
    });
  };
  saveAs = (blob: any, name: any) => {
    const url = window.URL.createObjectURL(blob);
    const aLink = document.createElement('a');
    aLink.style.display = 'none';
    aLink.href = url;
    aLink.setAttribute('download', name);
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  };

  exportPlan() {
    this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.exportDataApi();
      })
      .catch(() => {
        this.$message.info('已取消删除');
      });
  }
  exportDataApi() {
    // 服务加载的动画
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: publishObjectPath.serverUrl + `/api/yunnan/emergencyDrillRecord/export/word/${this.rowProp.data.id}`, // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
      })
      .catch(error => {
        loading.close();
        this.$message({
          type: 'error',
          message: '导出失败,请联系管理员!',
        });
        console.log(error);
      });
  }
}
